class NopeReference {
  key: string;

  constructor(key: string) {
    this.key = key;
  }
}

export default NopeReference;
